module.exports = "p {\r\n    margin-top: 5px;\r\n    margin-bottom: 5px;\r\n}"